import React from 'react';

const Backdrop = ({ click }) => (

    // Render a backdrop element
    <div className="backdrop" onClick={click} />
);

// Connect the Backdrop component to the Redux store and export it
export default Backdrop;